<template>
  <div
    id="sidebar_section"
    :class="[
      'sidebar proxima_nova text_color transition-all duration-300 ease-in-out hidden md:flex',
      isExpanded ? 'w-60' : 'w-14',
    ]"
  >
    <div class="flex flex-col w-full h-full justify-between">
      <div class="flex flex-col h-full overflow-y-scroll">
        <div class="flex flex-col w-full h-full justify-between">
          <div class="flex flex-col gap-1">
            <template v-for="option in sidebarOptions" :key="option.id">
              <router-link
                :to="option.route"
                v-if="isExpanded"
              >
                <SidebarItem
                  :option="option"
                  :is-expanded="true"
                  :is-selected="isOptionSelected(option)"
                  :is-disabled="false"
                />
              </router-link>

              <router-link
                :to="option.route"
                v-else
              >
                <a-tooltip placement="right" color="var(--tooltip-bg)">
                  <template #title>
                    <span class="text_color">{{ option.text }}</span>
                  </template>

                  <SidebarItem
                    :option="option"
                    :is-expanded="false"
                    :is-selected="isOptionSelected(option)"
                    :is-disabled="false"
                  />
                </a-tooltip>
              </router-link>
            </template>
          </div>
        </div>
      </div>

      <div
        :class="[
          'flex w-full transition-all duration-300 ease-in-out mt-4 mb-2',
          isExpanded ? 'justify-end px-2' : 'justify-center',
        ]"
      >
        <div @click="toggleExpand" class="card_container cursor-pointer p-2">
          <ThemeImage
            :icon="
              isExpanded
                ? imageNames.CHEVRON_ARROW_LEFT_GREY
                : imageNames.EXPAND_GREY
            "
            alt="expand_icon"
            class="size-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { imageNames } from "@/src/constants/imageConstants.js";
import { sidebarOptionPosition } from "@/src/constants/sidebarConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import SidebarItem from "@/src/components/sidebar_components/SidebarItem.vue";

const route = useRoute();
const isExpanded = ref(false);

const sidebarOptions = [
  {
    id: "assistant",
    text: "I Assistant",
    selected: imageNames.ASSISTANT_SELECTED,
    unselected: imageNames.ASSISTANT_UNSELECTED,
    route: "/",
    alignment: sidebarOptionPosition.TOP,
  },
  {
    id: "app_store",
    text: "Add Apps",
    selected: imageNames.APP_STORE,
    unselected: imageNames.APP_STORE,
    route: "/market",
    alignment: sidebarOptionPosition.TOP,
  },
];

const isOptionSelected = (option) => {
  if (option.id === "assistant") {
    return route.path === "/";
  }
  return route.path.startsWith(option.route);
};

const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<style>
.sidebar {
  padding: 2px 0 8px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: var(--foreground-rgb);
}

.sidebar_item {
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  transition: background-color 0.2s ease;
  margin: 0 8px;
}

.sidebar_item_selected,
.sidebar_item:not(.disabled):hover {
  background: var(--sidebar-item-selected);
}

.sidebar_item:not(.cursor-not-allowed):hover {
  background-color: var(--sidebar-item-selected);
}
</style>
